import { CreatePromocode } from './create-promocode';

export default CreatePromocode;